import React from 'react'
import Heading from './Heading'
import { roll } from './rollsData'
function Rolls() {
  return (
    <>
      <a href="/" id='rolls'></a>
          <div className="h-fit w-full p-4 font-fancy">
              <Heading heading="Rolls" />
              {roll.map((roll) => {
                  return <React.Fragment key={roll.id}>
                      <div className="my-5 p-4 flex justify-between shadow-2xl shadow-gray-700 drop-shadow-xl rounded-2xl ">
                          <h3 className="text-base font-bold">{roll.name}</h3>
                          <p className="rounded-r-full bg-gradient-to-tr from-yellow-200 to-yellow-500 font-extrabold px-1">{roll.price}</p>
                    </div>
                  </React.Fragment>
              })}
        </div>
    </>
  )
}

export default Rolls
